var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.00024L15.5 9.06237L16.7647 6.87177C18.1397 8.15003 19 9.97468 19 12C19 12.8808 18.8373 13.7236 18.5403 14.5001L20.6482 14.5C20.8773 13.7063 21 12.8675 21 12C21 9.23187 19.7505 6.75591 17.7847 5.10504L19 3L12 3.00024Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13468 10.4402C3.74944 6.92182 6.40756 4.10595 9.84102 3.2606L10.8953 5.08665C8.06753 5.53495 5.80344 7.67653 5.17447 10.4399H7.70996L4.20996 16.5023L0.709961 10.4402H3.13468Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C13.0805 21 14.1166 20.8096 15.0765 20.4604L16.29 22.5624L19.79 16.5L12.79 16.5002L14.0561 18.6931C13.406 18.8926 12.7155 19 12 19C9.80743 19 7.85031 17.9919 6.56681 16.414L5.51329 18.2388C7.15071 19.9409 9.45167 21 12 21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/transportation.451d895d8e6281f7b9fc503f390cfd89.svg";
export { ForwardRef as ReactComponent };